module.exports = __webpack_public_path__ + "img/shareQQ.bcbec028.png";